// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__nAuLM","wrapper":"footer_wrapper__SwjsY","navBar":"footer_navBar__Q1Nxl","formSubscribe":"footer_formSubscribe__AP5R1"};